import * as actionTypes from "../actionTypes";
import axios from "axios";



export const emailStart = () => {
    return {
      type: actionTypes.EMAIL_REQ_START
    };
  }
  
  export const emailSuccess = (message) => {
    return {
      type: actionTypes.EMAIL_REQ_SUCCESS,
    message:message
    }
  }
  
  export const emailFail = (error) => {
    return {
      type: actionTypes.EMAIL_REQ_ERROR,
      error: error
    }
  }


  export const emailForPassword = (email) => {
    return dispatch => {
      dispatch(emailStart());

      const loginData = {
        email: email
      }

      axios.post("/api/users/org_users/send_reset_password_link",loginData)
        .then(response => {
            dispatch(emailSuccess(response.data.message));
        })
        .catch(err => {
          dispatch(emailFail(err.response.data.message));
        });
    }
  }

  